import { apiGetWithAuth, fetchJsonWithAuth, ensureToken } from './authApi';
import { AUTH_URL, CANDIDATES_URL, JOBS_URL } from './apiConfig';

export async function getCandidateSummary(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  const query = params.toString();
  return apiGetWithAuth(CANDIDATES_URL, `/profile-summary${query ? `?${query}` : ''}`);
}

export async function getQuickSubmitCandidates({ isFromSubmission, jobId, submissionId, search = '' } = {}) {
  const body = { search };
  if (isFromSubmission) {
    body.submissionId = submissionId;
  } else {
    body.jobId = jobId;
  }
  const json = await fetchJsonWithAuth(CANDIDATES_URL, '/quicksubmit/list', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return json.data ?? json;
}

export async function getCandidateFormGroups(options = {}) {
  const token = await ensureToken();
  const params = new URLSearchParams({ module: 'candidates' });
  if (options.id) params.set('id', options.id);
  const res = await fetch(`${AUTH_URL}/admin/form-groups?${params}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`API ${res.status}: ${res.statusText}`);
  const json = await res.json();
  return json.data ?? json;
}

export async function getMentionUsers(search = '') {
  const params = search ? `?search=${encodeURIComponent(search)}` : '';
  return apiGetWithAuth(JOBS_URL, `/users/any${params}`);
}
